export default "__VITE_ASSET__BT_k$aIn__"